<template>
    <div class="contenedor_contenido">
        <div class="cabecera_contenido">

            <!-- <div class="btn_menu_contextual" @click="set_modulo('busqueda')">
                Búsqueda
            </div> -->


        </div>

        <div class="contenido_">
            <Registro />
        </div>
        <!-- <Busqueda v-if="modulo == 'busqueda'" /> -->

    </div>
</template>

<script>

    import Registro from './RegistroN.vue'

    export default {
        name: 'MenuMerma',
        components: {
            Registro
        },
        data() {
            return {

            }
        },
        methods: {

        },
    }
</script>

<style></style>